import { useCallback, useEffect, useState } from "react";
import { notification } from "antd";

import { getFriendlyErrorMessage } from "@/shared/services/http";
import { LanguagesIsoEnum } from "@/modules/assessments/types/test.interface";

import { ScaleAnalysesHttpService } from "./scale-analyses-http.service";
import { IScaleAnalysisReport } from "./scale-analyses.types";

export function useGetScaleAnalyses(testId: string | number | undefined) {
  const [scales, setScales] = useState<IScaleAnalysisReport[]>([]);
  const [availableLocales, setAvailableLocales] = useState<LanguagesIsoEnum[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const fetchScaleAnalyses = useCallback(async () => {
    if (!testId) {
      return;
    }

    try {
      setIsLoading(true);
      const data = await ScaleAnalysesHttpService.getScaleAnalysesForTest(testId);
      setScales(data.scales);
      setAvailableLocales(data.availableLocales);
    } catch (error) {
      notification.error({ message: getFriendlyErrorMessage(error) ?? "Failed to load scale reporting details." });
    } finally {
      setIsLoading(false);
    }
  }, [testId]);

  useEffect(() => {
    fetchScaleAnalyses();
  }, [fetchScaleAnalyses]);

  return { scales, availableLocales, isLoading, refresh: fetchScaleAnalyses };
}
